import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination } from '@mui/material';

import { useState, useEffect } from 'react';
import EditDialog from './EditDialog';

const columns = [
    { id: 'thirdPartyID', label: 'ID', minWidth: 30 },
    { id: 'thirdPartyName', label: 'Third Party Name', minWidth: 120 },
    { id: 'totalSalesBalance', label: 'Sales', minWidth: 120 },
    { id: 'totalDepositBalance', label: 'Deposit', minWidth: 120 },
    { id: 'totalReferralRequestBalance', label: 'Referral', minWidth: 120 },
    { id: 'totalPayoutRequestBalance', label: 'Payout', minWidth: 120 },
    { id: 'totalProcessingFees', label: 'Processing Fees', minWidth: 170 },
    { id: 'totalPackageRefundBalance', label: 'Package Refund', minWidth: 170 },
    { id: 'totalMistakeBalance', label: 'Mistake', minWidth: 120 },
    { id: 'totalCashInBalance', label: 'Cash In', minWidth: 120 },
    { id: 'totalCashOutBalance', label: 'Cash Out', minWidth: 120 },
    { id: 'totalBankFeesBalance', label: 'Bank Fees', minWidth: 120 },
    // { id: 'totalTelcoExpensesBalance', label: 'Telco Expenses', minWidth: 120 },
    // { id: 'totalStaffSalaryBalance', label: 'Staff Salary', minWidth: 120 },
    { id: 'totalTeamIncentiveBalance', label: 'Team Incentive', minWidth: 120 },
    { id: 'totalMarketerExpensesBalance', label: 'Markerter Expenses', minWidth: 120 },
    { id: 'totalUnclaimBalance', label: 'Unclaim', minWidth: 120 },
    // { id: 'totalShopPurchaseBalance', label: 'Shop Purchase', minWidth: 120 },
    // { id: 'totalCommissionBalance', label: 'Commission', minWidth: 120 },
    // { id: 'totalB2BInBalance', label: 'B2B In', minWidth: 120 },
    // { id: 'totalB2BOutBalance', label: 'B2B Out', minWidth: 120 },
    { id: 'totalProfitLoss', label: 'Profit/Loss', minWidth: 120 },
    { id: 'currentBalance', label: 'Balance', minWidth: 120 }
];

function StickyHeadTable({ thirdPartyReports, fetchThirdPartyReportRecords, thirdPartyBalanceTypes }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const [totals, setTotals] = useState({});

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        const calculateTotals = () => {
            const sums = {};
            const visibleRows = thirdPartyReports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

            visibleRows.forEach((row) => {
                columns.forEach((column) => {
                    if (column.id !== 'thirdPartyID' && column.id !== 'thirdPartyName') {
                        sums[column.id] = (sums[column.id] || 0) + (row[column.id] || 0);
                    }
                });
            });
            setTotals(sums);
        };

        calculateTotals();
    }, [thirdPartyReports, page, rowsPerPage]);

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* Row displaying totals */}
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} sx={{ fontWeight: '600' }}>
                                    {column.id === 'thirdPartyID'
                                        ? '' 
                                        : column.id === 'thirdPartyName'
                                        ? 'Total'
                                        : isNaN(totals[column.id])
                                        ? '-'
                                        : parseFloat(totals[column.id])?.toLocaleString()}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                        {thirdPartyReports.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <EditDialog
                                                fetchThirdPartyTotalBalance={fetchThirdPartyReportRecords}
                                                selectedThirdPartyID={row}
                                                thirdPartyBalanceTypes={thirdPartyBalanceTypes}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={thirdPartyReports.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
